export const RcfaBaseRoutes = {
  analysisList: 'list',
  graphDetail: 'graphDetail/:analysisId/:type',
  newAnalysis: 'new'
} as const
